export default "__VITE_ASSET__CAtVYu2l__"